import { Button } from '../../genericComponents/Button'
import { Card } from '../../genericComponents/Card'
import { FTUWizardHeader } from '../components/FTUWizardHeader'
import { WizardWrapper } from '../WizardWrapper'

export const FTUEnableTfaCard = (props: { setQrCodeRead: (read: boolean) => void }) => {
  const { setQrCodeRead } = props

  return (
    <Card title="">
      <WizardWrapper>
        <h1 className="text-primaryFontColor text-xl uppercase text-center tracking-widest font-bold m-3 my-6">
          Setup Two-Factor Authentication
        </h1>

        <FTUWizardHeader wizardStepCount={4} wizardActiveStep={2} />

        <div className="flex flex-col">
          <p className="m-0 mt-6 mb-6">
            Two-Factor Authentication is required for security reasons. Please user your mobile
            device to download the Google Authenticator app from the{' '}
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
              target="_blank"
            >
              Google Play
            </a>{' '}
            or{' '}
            <a
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              target="_blank"
            >
              App Store
            </a>
            , and use it to scan the barcode below.
          </p>

          <p className="m-0">
            Select <b>Continue</b> when you are done with the Google Authenticator app setup.
          </p>

          <img className="max-w-56 self-center m-4" src="/api/v1/qr" alt="Scannable QR Code" />

          <Button className="w-full my-8 uppercase" onClick={() => setQrCodeRead(true)}>
            Continue
          </Button>
        </div>
      </WizardWrapper>
    </Card>
  )
}
